import useSearchParams from '../../../hooks/useSearchParams';

const useFilterState = (filter) => {
  const [filterState, setFilterState] = useSearchParams({
    name: filter.name,
    serialize: filter.serialize,
    deserialize: filter.deserialize,
  });

  return [filterState, setFilterState];
};

export default useFilterState;
